import { EAPP_ROUTE } from "../enums/route.enum";

export const onboardingRoutes: Types.ObjectMap = {
  START_ONBOARDING: EAPP_ROUTE.START_ONBOARDING,
  SETUP_MULTI_ORGANIZATION_SUPPLIERS: EAPP_ROUTE.START_ONBOARDING,
  SETUP_SUPPLIERS: EAPP_ROUTE.START_ONBOARDING,
  SHARE_INVOICE_EMAIL: EAPP_ROUTE.POWER_OF_ATTORNEY,
  ESIGN_DOCUMENT_SIGNED: EAPP_ROUTE.SIT_BACK_AND_RELAX,
};
